<template>
  <div>
    <v-row>
      <v-col cols="12" :md="8" :sm="7">
        <PageTitle :title="$gettext('Photos & Videos') + ' ' + course.name" />
        <v-tabs color="primary" class="tabMedia">
          <v-tab><span v-translate class="text-md-h5 subtitle-1 font-weight-bold">Photos</span></v-tab>
          <v-tab><span v-translate class="text-md-h5 subtitle-1 font-weight-bold">Videos</span></v-tab>
          <v-tab-item class="white">
            <div v-if="photoList.length === 0" class="pa-5">
              {{showTextNoPost('photos')}}
            </div>
            <template v-else>
              <MediaPhotoList
              :photoList="photoList"
              @openDialogDetail="openDialogDetail"
              @loadmore="loadMorePhoto"
              :endData="endDataPhoto"/>
            </template>
          </v-tab-item>
          <v-tab-item class="white">
            <div v-if="videoList.length === 0" class="pa-5">
              {{showTextNoPost('videos')}}
            </div>
            <template v-else>
              <MediaVideoList
                :videoList="videoList"
                @openDialogDetail="openDialogDetail"
                @loadmore="loadMoreVideo"
                :endData="endDataVideo"/>
            </template>
          </v-tab-item>
        </v-tabs>
      </v-col>
      <v-col cols="12" :md="4" :sm="5">
        <DrawerRight />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import MediaPhotoList from "@/components/Card/MediaPhotoList";
import MediaVideoList from "@/components/Card/MediaVideoList";
import DrawerRight from "@/components/DrawerRight";
import PageTitle from "@/components/PageTitle";

export default {
  name: "CoursesMedia",
  metaInfo() {
    return {
      title: this.metaTitle,
      titleTemplate: null,
      meta: [
        {
          name: "description",
          content: this.metaDescription,
          vmid: 'description'
        },
      ],
    };
  },
  components: {
    MediaPhotoList,
    MediaVideoList,
    DrawerRight,
    PageTitle,
  },

  props: {
    isCourseAdmin: { type: Boolean, default: false },
  },
  data() {
    return {
      photoList: [],
      videoList: [],
      listVlog: [],
      currentPagePhoto: null,
      totalPagesPhoto: null,
      currentPageVideo: null,
      totalPagesVideo: null,
      endDataPhoto: false,
      endDataVideo: false
    };
  },
  async mounted() {
    let vm = this;
    vm.$root.$on('postSubmit', function(){
      vm.getAllData()
    });
    await vm.getAllData()
  },
  methods: {
    showTextNoPost(type) {
      if(type == 'photos') {
        return this.$gettext("No photos posted yet.")
      } else {
        return this.$gettext("No videos posted yet.")
      }
    },
    async getAllData() {
      const photo = await this.getListPhoto(1);
      this.photoList = photo;
      const video = await this.getListVideo(1);
      this.videoList = video;
    },
    async loadMorePhoto() {
      if (this.currentPagePhoto < this.totalPagesPhoto) {
        const page = (this.currentPagePhoto += 1);
        const photo = await this.getListPhoto(page);
        const list = this.photoList.concat(photo);
        this.photoList = list;
      }
    },
    async loadMoreVideo() {
      if (this.currentPageVideo < this.totalPagesVideo) {
        const page = (this.currentPageVideo += 1);
        const video = await this.getListVideo(page);
        const list = this.photoList.concat(video);
        this.videoList = list;
      }
    },
    openDialogDetail(listData, index, slide) {
      let mediaType = slide.type == MEDIA_TYPE_PHOTO ? "photo" : "video";
      const dataObj =
        slide.type == MEDIA_TYPE_PHOTO
          ? {
              currentPage: this.currentPagePhoto,
              totalPages: this.totalPagesPhoto,
            }
          : {
              currentPage: this.currentPageVideo,
              totalPages: this.totalPagesVideo,
            };
      this.$store.commit("openMediaView", {
        idModel: index,
        currentRoute: this.$route,
        mediaId: slide.id,
        mediaType,
        parentType: "course-media",
        parentId: 456,
        listMedia: listData,
        dataObj,
      });
    },
    async getListPhoto(page) {
      const photo = await this.$store.dispatch("getListMedia", {
        type: MEDIA_TYPE_PHOTO,
        page,
      });
      this.currentPagePhoto = photo.currentPage;
      this.totalPagesPhoto = photo.totalPages;
      if(photo.currentPage >= photo.totalPages) {
        this.endDataPhoto = true;
      } else this.endDataPhoto = false;
      return photo.list;
    },
    async getListVideo(page) {
      const video = await this.$store.dispatch("getListMedia", {
        type: MEDIA_TYPE_YOUTUBE,
        page,
      });
      this.currentPageVideo = video.currentPage;
      this.totalPagesVideo = video.totalPages;
       if(video.currentPage >= video.totalPages) {
        this.endDataVideo = true;
      } else this.endDataVideo = false;
      return video.list;
    },
  },
  computed: {
    course() {
      return this.$store.state.golfcourse.courseDetail;
    },
    metaTitle() {
      const binder = {
          courseName: this.course && this.course.name ? this.course.name : "",
      }
      const translated = this.$gettext("%{courseName} - Videos & Photos golf Courses");
      return this.$gettextInterpolate(translated, binder);
    },
    metaDescription() {
      const binder = {
          courseName: this.course && this.course.name ? this.course.name : "",
          countryName:
            this.course && this.course.country.name
              ? this.course.country.name
              : "",
      }
      const translated = this.$gettext("Videos & Photos at %{courseName} golf courses  in %{countryName}, Discover %{courseName} Videos & Photos of Golf courses. Check all the Golf courses photos at %{courseName}");
      return this.$gettextInterpolate(translated, binder);
    },
  },
};
</script>